import PropTypes from 'prop-types';
import React from 'react';
import Dialog from './Dialog';
import * as style from '../style';
import { translate } from '../../../common/i18n';

// same affiliate sign-up link as the header's Register button
const DERIV_SIGNUP_URL = 'https://track.deriv.com/_WIvoh588Vbw5TVC3w-F7AGNd7ZgqdRLk/1/';

const Choice = ({ onAuthorize, closeDialog }) => (
    <div className="bb3-dlg-b bb3-connect">
        <p className="bb3-help">{translate('Connect a Deriv account to run your bots and trade.')}</p>
        <button type="button" className="bb3-choice primary" onClick={onAuthorize}>
            <b>{translate('I have a Deriv account')}</b>
            <small>{translate('Authorize Trading Bots on Deriv and come straight back.')}</small>
        </button>
        <button
            type="button"
            className="bb3-choice"
            onClick={() => {
                window.open(DERIV_SIGNUP_URL, '_blank', 'noopener');
                closeDialog();
            }}
        >
            <b>{translate('Create a Deriv account')}</b>
            <small>{translate('Opens Deriv in a new tab. Come back here and connect once it is ready.')}</small>
        </button>
    </div>
);

Choice.propTypes = {
    closeDialog: PropTypes.func.isRequired,
    onAuthorize: PropTypes.func.isRequired,
};

export default class DerivConnectDialog extends Dialog {
    constructor(onAuthorize) {
        const closeDialog = () => this.close();
        super(
            'deriv-connect-dialog',
            translate('Connect your Deriv account'),
            <Choice
                closeDialog={closeDialog}
                onAuthorize={() => {
                    closeDialog();
                    onAuthorize();
                }}
            />,
            {
                ...style.dialogLayout,
                width  : 460,
                classes: { 'ui-dialog': 'bb3-dlg bb3-dlg-sm', 'ui-dialog-titlebar-close': 'icon-close' },
            }
        );
        this.registerCloseOnOtherDialog();
    }
}
